import * as React from 'react';
import { DeviceListProps } from './types';

export const DeviceListContext = React.createContext<
  DeviceListProps | undefined
>(undefined);
